var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* eslint-disable no-unused-expressions */
import { Component, Prop, Vue } from 'vue-property-decorator';
import { throttle } from 'lodash';
let InlineEditable = class InlineEditable extends Vue {
    constructor() {
        // #region @Props
        // @Prop({ default: '' })
        // protected value!: string;
        super(...arguments);
        // #endregion
        this.internalValue = '';
        this.element = null;
        // #region @Refs
        /**
         * ie.
         * @Ref()
         * readonly anotherComponent!: AnotherComponent
         */
        // #endregion
        // #region Class properties
        this.isLoading = false;
        this.isFocused = false;
        this.handleBlur = throttle(this.onBlur, 800);
        this.handleCancel = throttle(this.onCancel, 800);
        // #endregion
        // #region @Watchers
        /**
         * ie.
         * @Watch('company')
         * protected companyChanged() {
      
         * }
         */
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.internalValue = this.$attrs.value || '';
        this.element = this.$el.querySelector('.atabix-inline-editable__content');
        if (this.element) {
            this.element.innerText = this.internalValue;
        }
    }
    // #endregion
    // #region Class methods
    blurField(target) {
        this.isFocused = false;
        target.blur();
    }
    onKeydownEnter(event) {
        if (!this.multiline) {
            event.preventDefault();
        }
    }
    onFocus(event) {
        this.isFocused = true;
        if (!this.selectOnFocus) {
            return;
        }
        const cell = event.target;
        let range;
        let selection;
        if (window.getSelection) {
            selection = window.getSelection();
            range = document.createRange();
            range.selectNodeContents(cell);
            selection && selection.removeAllRanges();
            selection && selection.addRange(range);
        }
    }
    onBlur(event) {
        // if the originalValue and updatedValue are the same return
        if (this.internalValue === event.target.innerText) {
            this.isFocused = false;
            return;
        }
        this.onEndEdit(event.target);
    }
    onEndEdit(target) {
        // remove leading and trailing spaces
        this.isLoading = true;
        const event = {
            value: target.innerText.trim(),
            setSuccessState: () => this.setSuccessState(target),
            setFailedState: () => this.setFailedState(target),
        };
        this.$emit('update', event);
    }
    onCancel(event) {
        event.target.innerText = this.internalValue;
        this.blurField(event.target);
    }
    setSuccessState(target) {
        this.isLoading = false;
        // visual success flash
        target.parentElement && target.parentElement.classList.add('succeeded');
        setTimeout(() => {
            target.parentElement && target.parentElement.classList.remove('succeeded');
            this.internalValue = target.innerText.trim();
            this.blurField(target);
        }, 1000);
        this.$emit('update-succes');
    }
    setFailedState(target) {
        this.isLoading = false;
        target.innerText = this.internalValue;
        this.$emit('update-failed');
        // visual error flash
        target.parentElement && target.parentElement.classList.add('failed');
        setTimeout(() => {
            target.parentElement && target.parentElement.classList.remove('failed');
            target.focus();
        }, 1000);
    }
    // #endregion
    // #region Async methods
    /**
     * ie.
     * protected async fetchUserCompany(): Promise<void> {
     *  this.company = await new Company().filter({user: this.user.id}).all();
     * }
     */
    // #endregion
    // #region Getters & Setters
    get alignmentClasses() {
        return this.align === 'left'
            ? 'text-left flex-row'
            : 'text-right flex-row-reverse';
    }
};
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], InlineEditable.prototype, "classes", void 0);
__decorate([
    Prop({ default: 'left' }),
    __metadata("design:type", String)
], InlineEditable.prototype, "align", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], InlineEditable.prototype, "multiline", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], InlineEditable.prototype, "selectOnFocus", void 0);
InlineEditable = __decorate([
    Component({})
], InlineEditable);
export default InlineEditable;
